module.exports = __webpack_public_path__ + "img/success_OLD_8.d1f8ee97.gif";